"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Branding = void 0;
var react_1 = __importStar(require("react"));
var storybook_1 = require("@eyecons/storybook");
var ra_fetch_1 = require("ra-fetch");
function initChannel(id) {
    return {
        channel_id: id,
        id: null,
        icon: '',
        logo: '',
        banner: '',
        watermark: '',
        videowall_sponsor: ''
    };
}
var Branding = function (_a) {
    var id = _a.id;
    var _b = storybook_1.Hooks.useModal(), Modal = _b[0], setModal = _b[1], closeModal = _b[2];
    var _c = react_1.useState(''), active = _c[0], setActive = _c[1];
    var _d = ra_fetch_1.useApi('backend')
        .mapping({
        icon: 'options.icon',
        banner: 'options.banner',
        logo: 'options.logo',
        watermark: 'options.watermark',
        videowall_sponsor: 'options.videowall_sponsor',
    })
        .update('channels', initChannel(id), {
        channel_id: id,
        id: id,
        details: true,
    }), channel = _d[0], setChannel = _d[1], submitChannel = _d[2];
    if (channel.loading) {
        return react_1.default.createElement(storybook_1.Icons.Icon, { name: 'loader' });
    }
    if (!channel.data.id && !channel.loading) {
        return react_1.default.createElement(storybook_1.Pages.Dashboard.NotFound, null);
    }
    function onChange(key, file) {
        var _a;
        setChannel((_a = {},
            _a[key] = file,
            _a));
    }
    function onSubmit(active, params, title) {
        if (params === void 0) { params = {}; }
        if (title === void 0) { title = 'Uploaden voltooid'; }
        setActive(active);
        return submitChannel(params).then(function (response) {
            if (!response.errors.length) {
                setModal({
                    content: function () { return react_1.default.createElement(storybook_1.Forms.Success, { title: title, subtitle: 'Het kan enkele minuten duren totdat je wijziging zichtbaar is', onClose: function () {
                            closeModal();
                            setActive('');
                        }, returnUrl: process.env.NEXT_PUBLIC_STORYBOOK_DASHBOARD_V2_URL + "/videos" }); }
                });
            }
        });
    }
    return react_1.default.createElement(storybook_1.Layouts.Container, { className: 'storybook-layouts-space' },
        react_1.default.createElement(Modal, null),
        react_1.default.createElement(storybook_1.Channels.Branding, { channel: channel, onChange: onChange, onSubmit: onSubmit, active: active, onDelete: function (brand) {
                var _a;
                return onSubmit(brand.name, (_a = {}, _a[brand.name] = '', _a.details = true, _a), 'Verwijderen voltooid').then(function () {
                    onChange(brand.name, '');
                });
            } }));
};
exports.Branding = Branding;
exports.Branding.propTypes = {};
exports.Branding.defaultProps = {};
